import AdministratorLayout from './administrator_layout.jsx';

const AdministratorPage = () => {
  return (
      <AdministratorLayout />
  );
};

export default AdministratorPage;